<template>
  <v-layout column class="zoom-control-wrapper">
    <v-flex
      id="zoom-canvas-wrapper"
      class="zoom-canvas-wrapper interactive-canvas-wrapper"
      :style="canvasWrapperStyle"
      ref="zoomControl"
      @wheel.exact.prevent="handleCanvasWheel"
      @mousedown.self="handleMousedown"
      @mousemove="handleMousemove"
      @mouseup.self="handleMouseup"
      @mouseout.self="handleMouseout"
      @click="handleClick"
      v-hammer:press="handlePanstart"
      v-hammer:panstart="handlePanstart"
      v-hammer:pan="handlePanmove"
      v-hammer:panend="handlePanend"
      v-hammer:tap="handleTap">
      <image-not-found v-if="imgNotFound" />
      <canvas-image :canvasSize="fit"
        :imgSize="fit"
        :isFlipped="isFlipped"
        :isFlipped90="isFlipped90"
        :img="img" 
        name="imageZoom"/>
      <canvas-annotation v-if="debug"
        :canvasSize="fit"
        :imgSize="fit"
        :annotation="grid" />
      <canvas-annotation :canvasSize="fit" :imgSize="fit" :annotation="viewFinder" />
      <v-progress-circular v-if="imgIsLoading" class="escalon-absolute-center" indeterminate />
      <span class="zoom-level-info">{{zoom.toFixed(2)}} x</span>
    </v-flex>
    <v-flex >
      <v-slider
        class="transform-slider"
        :value="zoom"
        track-color="#7f7f7f"
        :color="colorHex"
        @input="rateLimitedUpdateZoom"
        @focus="stopFitZoom"
        always-dirty
        :min="minZoom"
        :max="maxZoom"
        step="0.01">
        <template slot="prepend">
          <circle-slot-button title="Zoom Out"
            :btnClass="colorClass"
            size="xSmall"
            @click="updateZoom(zoom - 0.05)">
            <v-icon size="18">fas fa-minus</v-icon>
          </circle-slot-button>
        </template>
        <template slot="append">
          <circle-slot-button title="Zoom In"
            :btnClass="colorClass"
            size="xSmall"
            @click="updateZoom(zoom + 0.05)">
            <v-icon size="18">fas fa-plus</v-icon>
          </circle-slot-button>
        </template>
      </v-slider>
    </v-flex>
  </v-layout>
</template>

<script>
import canvasImage from "../../../canvas/components/CanvasImage";
import canvasAnnotation from "../../../canvas/components/CanvasAnnotation";
import ViewFinder from "../../../canvas/annotations/viewFinder";
import Grid from "../../../canvas/annotations/grid";
import circleSlotButton from "../../controls/CircleSlotButton";
import touchMouseEvents from "../../mixins/TouchMouseEvents";
import imageNotFound from "../../misc/ImageNotFound";
import { limit } from "../../../helpers/utils";

export default {
  name: "imageZoomControl",
  components: { canvasImage, canvasAnnotation, circleSlotButton, imageNotFound },
  mixins: [touchMouseEvents],
  props: [
    "imgNotFound",
    "img",
    "imgIsLoading",
    "transform",
    "size",
    "fit",
    "isFlipped",
    "isFlipped90",
    "height"
  ],
  data() {
    return {
      viewFinder: new ViewFinder(),
      debug: false,
      disableCustomEvents: false
    };
  },
  computed: {
    minZoom() {
      return (this.transform && this.transform.minZoom) || 0.05;
    },
    fitZoom() {
      return (this.transform && this.transform.fitZoom) || 1;
    },
    maxZoom() {
      return (this.transform && this.transform.maxZoom) || 3;
    },
    centerX() {
      return (this.transform && this.transform.centerX) || 0.5;
    },
    centerY() {
      return (this.transform && this.transform.centerY) || 0.5;
    },
    zoom() {
      return (this.transform && this.transform.zoom) || 1;
    },
    grid() {
      return new Grid(this.fit);
    },
    canvasWrapperStyle() {
      return {
        height: this.height || "200px"
      };
    }
  },
  methods: {
    handleInteractionStart(e) {
      if (this.transform.zoom <= this.transform.fitZoom)
        this.setDisableCustomEvents(true);
      else
        this.setDisableCustomEvents(false);
      this.setCanvasLocation(e.offsetX, e.offsetY);
    },
    handleInteractionMove(e) {
      this.setCanvasLocation(e.offsetX, e.offsetY);
    },
    handleCanvasWheel(e) {
      this.updateZoom(this.transform.zoom + e.deltaY * -0.001);
      this.setCanvasLocation(e.offsetX, e.offsetY);
    },
    rateLimitedUpdateZoom(zoom){
      if (this.limitUpdateZoom){
        this.limitUpdateZoom(zoom);
      }
    },
    updateZoom(zoom) {
      this.$emit("stopFitZoom");
      this.$emit("updateZoom", zoom);
    },
    setCanvasLocation(x, y) {
      const centerX = (x - (this.size.w - this.fit.w) / 2) / this.fit.w;
      const centerY = (y - (this.size.h - this.fit.h) / 2) / this.fit.h;
      this.$emit("updateCenter", { x: centerX, y: centerY });
    },
    setDisableCustomEvents(val) {
      this.disableCustomEvents = val;
    },
    stopFitZoom(){
      this.$emit("stopFitZoom");
    }
  },
  mounted(){
    this.limitUpdateZoom = limit(this.updateZoom.bind(this), 30);
  },
  watch: {
    disableCustomEvents() {
      if (this.disableCustomEvents)
        this.$refs.zoomControl.style.touchAction = "auto";
      else
        this.$refs.zoomControl.style.touchAction = "none";
    },
    transform: {
      handler() {
        this.viewFinder.updateViewFinder(this.fit, this.transform);
      },
      deep: true
    }
  }
};
</script>